export const appStrings_heIL = {
	"sign_in_by_phone_message": "היי! כיף לראות אותך",
	"enter_code_message": "שלחנו לכם קוד אימות למספר",
	"sign_in_by_email_message": "היי, אנא הכנסו עם אימייל וסיסמא",
	'verification_code_message': '{{pincode}} הוא קוד האימות שלכם.',
	'resend': 'שלחו שוב',
	'error_general': 'ארעה שגיאה לא ידועה. אנא נסו שוב.',
	'error_invalid_phone_verification_code': 'נראה שהקוד אינו נכון או שפג תוקפו. אנא נסו שוב.',
	'error_invalid_sign_in_email_already_exists': 'אימייל זה קיים במערכת. יש להכניס אימייל אחר.',
	"sign_up_message": "נשמח להכיר קצת",
	"sign_update_message": "רק עוד טיפה וסיימנו",
	'confirmation_password_reset': 'אימייל עם הוראות כיצד לחדש את הסיסמא נשלח לתיבה שלכם.',
	'error_reset_password_missing_email': 'אנא מלאו את כתובת הדואר האלקטרוני שלכם על מנת לחדש את הסיסמא.',
	'invalid_email_entered': 'כתובת הדואר אלקטרוני שהוזנה אינה חוקית',
	'error_reset_password': 'נראה שהאימייל שלכם אינו תקין או שאינו קיים במערכת. אנא נסו שוב או הרשמו מחדש.',
	"anonymous_orderer": "מזדמן",
	"cell": "מספר סלולרי",
	'order': 'משלוחים',
	'pay': 'תשלום',
	'default': 'ברירת מחדל',
	'save': 'שמור',
	'okay': 'המשך',
	'close': 'סגור',
	'back': 'חזור',
	'continue': 'המשך',
	'checkout': 'המשך',
	'register': 'הרשם/י',
	'remove': 'להסיר',
	'reorder_action': 'הזמן שוב!',
	'more': 'עוד',
	'load_more_orders': ' טעינת הזמנות נוספות',
	'loading_order_details': 'טוען פרטי הזמנה...',
	'delivery': 'משלוח',
	'take_away': 'לקחת',
	'takeaway': 'איסוף עצמי',
	'seated': 'ישיבה',
	'_and': 'ו',
	'verification_code': 'קוד אימות',
	'error_title': 'רגע...',
	'error_invalid_sign_in_credentials': 'נראה שהאימייל או הסיסמא אינם נכונים. אנא נסו שוב.',
	'confirmation_title': 'אישור',
	'main': 'ראשי',
	'logout': 'התנתקות',
	'name': 'שם',
	'phone': 'טלפון',
	'invalid_phone': 'טלפון לא חוקי',
	'email': 'דוא״ל',
	'password': 'סיסמא',
	'reset_password': 'שכחתי סיסמא',
	'forgot_your_password': 'שכחתי את הסיסמא',
	"auth_enable_anonymous": "<span class='text-lighter text-xs'>לא מצליחים לקבל סמס?&nbsp;</span><div>המשיכו כאורח</div>",
	'auth_q': 'רוצה לחסוך זמן?',
	'auth_q_cont': 'הרשמה / התחברות',
	'preparing-food': 'ברגע שיתווספו מנות להזמנה ניתן יהיה לראות אותם כאן',
	'sign_in_nav': 'הרשמה / התחברות',
	'sign_in_action': 'המשך',
	'sign_in_title': 'התחברות',
	'sign_up_action': 'המשך',
	'sign_up_q': 'פעם ראשונה כאן?',
	'sign_up_q_cont': 'הרשמה',
	'sign_up_prompt_title': 'וואו איזה מוזר, עדיין אין לך\nמשתמש ב-',
	'sign_up_prompt_content': 'בהרשמה קצרצרה ניתן\nלשמור את אמצעי התשלום\nבארנק הדיגיטלי שלנו,\nלתשלומים קלים ומהירים בעתיד',
	'sign_up_prompt_ok': 'קחו אותי להרשמה',
	'sign_up_prompt_cancel': 'המשך כאורח',
	'search': 'חיפוש',
	'sold_out': 'אזל',
	'my_account': 'האיזור שלי',
	'my_account_description': 'באפשרותכם לערוך כאן את פרטיכם האישיים או לבחור סיסמא חדשה.',
	'personal_information': 'פרטים אישיים',
	'first_name': 'שם פרטי',
	'card_holder_name': 'מי משלם',
	'received_payments': 'תשלומים שהתקבלו',
	'last_name': 'שם משפחה',
	'mobile': 'טלפון נייד',
	'my_wallet': 'אמצעי תשלום',
	'my_wallet_info': 'הגדרת אמצעי תשלום',
	'my_wallet_description': 'באפשרותכם להוסיף ולערוך אמצעי תשלום, ולשנות את אמצעי התשלום הדיפולטיבי.',
	'add_to_wallet': 'הוסף לארנק',
	'credit_card_number': 'מספר כרטיס',
	'credit_type': 'סוג כרטיס',
	'cvv': '3 ספרות בגב הכרטיס',
	'comments': 'הערות',
	'my_history': "היסטוריית הזמנות",
	'my_history_info': 'הזמנות פתוחות והסטוריה',
	'my_history_description': 'כל הביקורים וההזמנות שלכם מופיעים ברשימה הבאה',
	'by_site': 'לפי מסעדה',
	'by_date': 'לפי תאריך',
	'add_pm': 'הוספת אמצעי תשלום',
	"please_confirm": "אנא אשר",
	"please_enter_value": "אנא הזן ערך",
	"are_you_sure": "האם אתה בטוח?",
	"Cancel": "ביטול",
	"update_account": "עדכון פרטים",
	"view_bill": "צפייה בחשבון",
	"goto-rest-page": "מעבר לעמוד המסעדה",
	"reload_app": "טעינת העמוד מחדש",
	"reload_app_info": "בסביבת בדיקות בלבד גרסה: ",
	"enter_order_no": "הזן קוד הזמנה",
	"order_short_code": "קוד הזמנה",
	"open_in_app": "פתיחה באפליקציה",
	"OR": "או",
	"AMOUNT_TO_PAY": "סכום לתשלום",
	"TIP_TO_PAY": "טיפ",
	"TABLE_BILL": "חשבון לשולחן",
	"WAITER": "מלצר",
	"PAY_WITH": "שלמו באמצעות",
	"PAY_WITH_WALLET": "שלם באמצעות הארנק שלך",
	"SELECT_ALTERNATE_PYMENT": "בחר באמצעי תשלום אחר",
	"PAY": "שלם",
	"clear": "נקה",
	"please_enter_signature": "לאישור תשלום חתום כאן",
	"notes": "הערות",
	"next": "המשך",
	"day": "יום",
	"download_invoice": "להורדת החשבונית",
	"view_invoice": "לצפיה חשבונית",
	"partial_payment": "תשלום חלקי",
	"split_payment_by": "חלוקת חשבון לפי",
	"other": "אחר",
	"gratuity": "טיפ",
	"add_gratuity": "הוספת טיפ",
	"current_gratuity": "טיפ בהזמנה עד כה",
	"current_payment": "סה\"כ לתשלום",
	"order_balance": "שארית תשלום",
	"without_gratuity": "ללא טיפ",
	"GRATUITY_AMOUNT": "סכום טיפ",
	"amount": "סכום",
	"GRATUITY_PERCENT": "אחוז טיפ",
	"percent": "אחוז",
	"ENTER_CVV": "הזן CVV",
	"SAVE_ACCOUNT_PAYMENT_INFO": "שמירת אמצעי התשלום בארנק הדיגיטלי שלנו, לתשלומים קלים ומהירים בעתיד",
	"expiration": "תוקף",
	"PASS_ORDER": "חולקים חשבון?",
	"PASS_ORDER_TITLE": "העבר לחבר",
	"MAKE_ADDITIONAL_PAYMENT_ONDEVICE": "תשלום נוסף במכשיר זה",
	"PASS_ORDER_BY_PHONE_MESSAGE": "להעברת הקישור בהודעת טקסט יש להכניס מספר טלפון",
	"PASS_ORDER_BY_PHONE_CAPTION": "מספר סלולרי",
	"PASS_ORDER_BY_PHONE_SEND": "שלח הזמנה",
	"PASS_ORDER_BY_PHONE_QR_MESSAGE": "או לסרוק את הברקוד",
	"PASS_ORDER_SENT_SUCCESS": "ההזמנה נשלחה בהצלחה",
	"CANNOT_SEND_ORDER_BY_SMS": "אנו מתנצלים, אך כרגע לא ניתן לשלוח את הקישור.",
	"READ_AND_APPROVE_CONTRACT": "קראתי ואני מסכים",
	"READ_AND_APPROVE_CONTRACT_C": "לתנאי השימוש",
	"READ_AND_APPROVE_CONTRACT_D": "למדיניות הפרטיות",
	"CONTRACT_C": "תנאי השימוש",
	"CONTRACT_D": "מדיניות הפרטיות",
	"WELCOME_BACK": "ברוכים השבים, {{name}}",
	"CONTINUE_WITHOUT_GRATUITY": "המשך ללא טיפ",
	"WITHOUT_GRATUITY": "ללא טיפ",
	"PERFORMING_PAYMENT": "מבצע תשלום...\nנא לא לסגור את הדפדפן",
	'full-payment': 'תשלום מלא',
	'partial-payment': "תשלום חלקי",
	'pay-with-saved': "תשלום באמצעות הכרטיס השמור",
	"ID_CARD": "תעודת זהות של בעל הכרטיס",
	"ENTER_IDCARD": "הזן תעודת זהות",
	"ENTER_IDCARD_MESSAGE": "הזן תעודת זהות לכרטיס: {{card}}",
	"GOT_IT": "הבנתי",

	"split_amount_topay": "בחר את החלק עליו תרצה לשלם",
	"split_check_name": "חשבון {{v}}",
	"table": "שולחן",
	"nutritional_info": "מידע תזונתי",
	"service_charges_applied": "{{name}} כלולים בחשבון",
	"app_smart_banner_title": "למה ככה בדפדפן?",
	"app_smart_banner_body": "באפליקציה יותר כיף :)",
	"waiter_payment": "תשלום מלצר",
	"additional_details": "פרטים נוספים",
	"yes": "כן",
	"no": "לא",
	"diner": "סועד",
	"address": "כתובת",
	"zip": "מיקוד",
	"state": "מדינה",
	"city": "עיר",
	"billing_address": "כתובת לחיוב",
	"add-item": "הוספה",
	"add-items": "הוספת פריטים",
	"goto-payment": "בחירת אופן תשלום",
	"goto-tip": "הוספת טיפ",
	"EX_PAYMENT_MODAL": "בצע תשלום",
	"select_items": "בחר פריטים",
	"pay_by_items": "תשלום לפי פריט",
	"pay_by_diners": "תשלום לפי סועד",
	"pay_by_items_title": "אני רוצה לשלם על...",
	"pay_by_items_discount": "הנחת הזמנה בסך {{val}} מחולקת באופן יחסי בין הפריטים",
	"partial_payment_title": "כמה תרצו לשלם?",
	"partial_payment_calcs_title": "אפשרויות חישוב נוספות",
	"paying_for": "משלמים על",
	"out_of": "מתוך",
	"at_the_table": "בשולחן",
	"back_to_bill": "בחזרה לחשבון",
	"server_knows": "הצוות יוכל לראות ששילמת",
	"want_to_add_tip": "רוצים להוסיף טיפ?",
	"want_to_add_more_tip": "להוסיף עוד טיפ?",
	"order_payed_in_full": "ההזמנה שולמה במלואה",
	"whoIsPaying": "מי משלם?",
	"surcharge_will_be_added_to_tip": "היתרה תתוסף לטיפ",
	"EX_PAYMENT": {
		"dialog_title": "אישור עסקה",
		"wallet_title": "אישור כרטיס",
		"wallet-popup-title": "תהליך שמירת הכרטיס עבר בהצלחה",
		"description": "עמוד זה משמש לאישור העסקה עבור תשלום באתר. התשלום יבוצע בפועל רק לאחר השלמת התהליך בדף בית העסק. יש לאשר תחילה כי כל הפרטים בדף זה נכונים ולמלא את פרטי האשראי כנדרש.",
		"popup-title": "העסקה אושרה לביצוע",
		"form-title": "פרטי כרטיס אשראי",
		"popup-description": "התשלום בפועל יבוצע לאחר השלמת הפעולה",
		"submit-btn": "המשך",
		"clear": "איפוס",
		"credit_card_number": "מספר כרטיס",
		"expiration": "תוקף כרטיס",
		"cancel": "ביטול",
		"currency": "מטבע:",
		"transaction_details": "פרטי העסקה",
		"total_amount": "סכום",
		"month": "חודש",
		"year": "שנה",
		"click_here": "לחצו כאן למעבר",
		"save":"שמירה",
		"error_client_credentials": "ארעה שגיאה... אנא נסו שוב.",
        "error_cg_wallet_credentials": "פרטי הכרטיס שגויים... אנא נסו שוב.",
		"wallet_add_pending": "הבקשה שלך בטיפול, וייתכן שיחלפו עד 10 דקות עד שהשינויים יופיעו בחשבונך.",
		"Q_SAVEPM_1": "מעוניינים לקצר את זמן ההזמנה?",
		"Q_SAVEPM_2": "ניתן לשמור את אמצעי התשלום בארנק הדיגיטלי שלנו, לתשלומים קלים ומהירים בעתיד",
		"Q_SAVEPM_3": "תשלום ושמירה",
		"Q_SAVEPM_4": "תשלום ללא שמירה",
	},
	"_LOYALTY": {
		"sign_title": "הרשמה / התחברות",
		"sign_description": "בהרשמה קצרצרה ניתן לשמור את אמצעי התשלום בארנק הדיגיטלי שלנו, לתשלומים קלים ומהירים בעתיד",
		"sign_other": "הזינו את מספר הטלפון ולחצו על המשך",
		"register_title": "הרשמה",
		"confirm_title": "רק עוד רגע וסיימנו…",
		"banner_title_start": "הירשמו לארנק הדיגיטלי של",
		"banner_title_end": "לתשלום מהיר",
		"banner_save_time": "היי, רוצים לחסוך זמן",
		"banner_side_start": "הכירו את הארנק הדיגיטלי של",
		"banner_side_end": "לתשלומים קלים ומהירים במגוון מסעדות",
		"banner_side_ligin_start": "הינך מחובר/ת לחשבון של",
		"hi_name": "הי {{name}}",
		"welcome": "ברוכים הבאים!",
		"sprompt_desc": "הדרך הקלה והמהירה להסדיר את החשבון בעצמך",
		"sprompt_ok": "התחברות ל-<ilogow></ilogow><br> לתשלום מהיר",
		"sprompt_cancel": "המשך כאורח",
		"sprompt_license": "על ידי שימוש ב- Tabit Pay הינך מסכים",
		"sprompt_desc_additems": "תצטרכו להתחבר על מנת להמשיך",
		"sprompt_ok_additems": "התחברות ל <ilogow></ilogow>",
		"sprompt_cancel_additems": "ביטול",
		"sprompt_license_additems": "השימוש ב-Table@ מהווה הסכמה",
		"sprompt_desc_tabitorder": "תצטרכו להתחבר על מנת להמשיך",
		"sprompt_ok_tabitorder": "התחברות ל <ilogow></ilogow>",
		"sprompt_cancel_tabitorder": "ביטול",
		"sprompt_license_tabitorder": "על ידי שימוש ב- Table@ הינך מסכים",
		"tabit_wallet": "ארנק <ilogod></ilogod>",
		"loyalty_required": "על מנת להתקדם בהזמנה, יש להזין את כרטיס המועדון",
		"code_with_letters": "יש לי שובר עם אותיות",
		"enter_code_with_letters": "קוד שובר",
		"cancel_benefits": "ביטול הטבות",
		"card_balance": "יתרה בכרטיס נטען",
		"benefits": "הטבות",
		"connect_info": "מה מספר הטלפון או השובר שלך?",
		"expires": "בתוקף עד",
		"greeting": "היי {{name}}",
		"greeting_voucher": "היי",
		"loginSubCaption": "התחברות, הצטרפות למועדון או מימוש שובר",
		"loginSubCaptionVoucher": "למימוש שובר",
		"member_not_found": "לא נמצא חבר מועדון או שובר",
		"of": "מ-",
		"points_balance": "נקודות שצברתי",
		"punch_card_offer": "נותר {{from}} מ {{to}}",
		"review_points": "מימוש נקודות",
		"use_points": "נקודות",
		"signout": "התנתקות",
		"skip": "דלגו",
		"title": "חברי מועדון {{name}}?",
		"title_voucher": "היי, יש לך שובר?",
		"title_club": "הנחות והטבות? ברור שכן!",
		"voucher": "שובר",
		"max_redeemable_points": "מקסימום נקודות למימוש",
		"my_benefits": "ההטבות שלי",
		"my_balance": "יתרה",
		"redeem_points_prompt_1": "הנקודות שלך שוות כסף!",
		"redeem_points_prompt_2": "מקסימום נקודות למימוש בהזמנה זו {{points}}",
		"redeem_points_after": "חסכת {{points}} בעזרת מימוש נקודות",
		"select_club": "באיזה מועדון מבלים היום?",
		"not_interested_club": "הזמנה ללא מועדון או שובר",
		"not_interested_voucher": "הזמנה ללא שובר",
		"auth_title": "קוד אימות",
		"auth_sub_title": "שלחנו קוד למספר הטלפון שעדכנת",
		"auth_code": "קוד אימות",
		"auth_resend": "שלחו לי שוב",
		"auth_verification_failed": "הקוד שהוזן אינו תואם",
		"error_voucher_redeemed": "שובר זה מומש כבר",
		"select_benefits": "אילו הטבות לממש היום?",
		"select_additional_benefits": "אולי תרצו להוסיף את ההטבות האלה?",
		"edit_benefits": "עריכת הטבות",
		"back_to_menu": "חזרה לתפריט",
		"select_benefits_max": "ניתן לממש עד {{val}} הטבות בהזמנה",
		"select_count_offers_for_benefit": "בחרו <b class='hl1'>{{val}}</b> פריטים למימוש ההטבה",
		"select_one_offers_for_benefit": "בחרו פריט <b class='hl1'>אחד</b> למימוש ההטבה",
		"benefit_offers_selected_count": "נבחרו <b class='hl2'>{{val}}</b> פריטים",
		"benefit_offers_selected_count_one": "נבחר פריט <b class='hl2'>אחד</b>",
		"store_points": "חנות נקודות",
		"compensation": "פיצוי כספי",
		"select_item": "הבחירה שלי",
		"confirmCancel_benefit": "לבטל את ההטבה שבחרת?",
		"confirmDeleteOffer_reserved": "הסרת הפריט תבטל ההטבה!\nלהסיר את הפריט?",
		"your_auto_benefits": "עוד הטבות שמחכות לך אצלנו",
		"pay_with": "תשלום ב",
		"btn_bar_edit": "המועדון שלי",
		"error_renew_forbidden": "החברות במועדון הסתיימה.\nיש לחדש את החברות כדי להמשיך ליהנות מהטבות המועדון",
		"CustomerMustCompleteTheRegistration": "על מנת להוסיף את חבר המועדון להזמנה,\nיש תחילה למלא את טופס ההרשמה שנשלח\nבהודעת סמס או באפליקציה שלנו",
		"minimum_order_required_message": "עוד קצת ומגיעים למינימום\nאחרי חישוב ההטבות,\nהסכום לתשלום הוא {{currency}}{{total}}\nוהוא נמוך מהמינימום להזמנה -  {{currency1}}{{amount}}"
	},
	"_LOYALTY_REG": {
		"registration_error": "ארעה שגיאה, לא מצליח להרשם",
		"registration_update_error": "ארעה שגיאה, בעדכון הרישום",
		"missing_offers_error": "לא נמצאו הצעות הרשמה",
		"missing_offers_reg_error": "לא ניתן להשלים את תהליך ההצטרפות, יש לפנות למסעדה",
		"first_name": "שם פרטי",
		"last_name": "שם משפחה",
		"register": "התחברות",
		"regTitle": "חברי מועדון נהנים יותר!",
		"regDetailsTitle": "חברי מועדון נהנים יותר!",
		"regDetailsDescription": "נרשמים למועדון ומתחילים ליהנות\n מהטבות ששמורות רק לחברים שלנו",
		"regSuccessTitle": "חברי מועדון נהנים יותר!",
		"regSuccesCaption": "כדי שנוכל להמשיך לצ'פר אותך, יש למלא את כל הפרטים בלינק שנשלח אליך ב-SMS",
		"regPaySuccesCaption": "כדי שנוכל להמשיך לצ'פר אותך, יש למלא את כל הפרטים בלינק שנשלח אליך ב-SMS",
		"sms_additional_info_sent_reg": "יש עוד המון הטבות!\nכדי ליהנות מהן, שלחנו לך ב-SMS\n לינק להשלמת פרטים",
		"sms_additional_info_sent_update": "יש עוד המון הטבות!\nכדי ליהנות מהן, שלחנו לך ב-SMS\n לינק להשלמת פרטים",
		"regPaySuccesComment": "*ההצטרפות למועדון כרוכה בתשלום של {{price}}, החיוב יתווסף אוטומטית להזמנה",
		"regCancelSMSPrompt": "לא זמן מתאים?\n\nזה ממש בסדר, נוכל לשלוח לך הודעת sms עם לינק להרשמה, כך ניתן יהיה להנות מהטבות המועדון גם בהמשך!",
		"loginPayExpiredTitle": "מזמן לא נפגשנו {{name}}",
		"loginPayExpiredCaption": "כדי שנוכל להמשיך לצ'פר אותך אנחנו צריכים לחדש את המועדון",
		"loginPayExpiredComment": "*חידוש החברות במועדון כרוך בתשלום של {{price}}, החיוב יתווסף אוטומטית להזמנה",
		"confirmDeleteOffer": "הסרת פריט ההצטרפות תבטל את הרשמתך למועדון\nבאמת להסיר את הפריט ונפרד כידידים?",
		"removeOfferButton": "הסר פריט",
		"keepOfferButton": "אה, לא משנה",
		"membership_expired_at": "חבר מועדון פג תוקף ב",
		"registration_contract": "קראתי ואישרתי את תנאי המועדון",
		"read_contract": "לקריאת תנאי ההצטרפות למועדון",
		"registration_terms": "המועדון יכול לשלוח לי חומרים פרסומיים מעת לעת באמצעות מסרונים.\nאוכל להסיר את עצמי מרשימת התפוצה בכל עת.",
		"birthDate": "תאריך לידה",
		"anniversary": "יום נישואין",
		"email": "אימייל",
		"zehut": "תעודת זהות",
		"another_time": "בפעם אחרת",
		"no_thanks": "לא תודה",
		"send_sms": "שלחו לי",
		"after_reg_add_details_title": "{{name}}\nאיזה כיף שהצטרפת למועדון!",
		"after_reg_add_details_description": "נשמח לעדכן כמה פרטים כדי שנוכל לתת לך את מלוא ההטבות של המועדון",
		"after_reg_benefits_caption": "אלה כמה מההטבות שמחכות לך במועדון שלנו",
		"terms_required_title": "{{name}}",
		"terms_required_description": "ראינו שעוד לא סיימת את ההרשמה, עוד רגע וההטבות אצלך",
		"expired_soon_title": "הזמן טס כשטעים!",
		"expired_soon": "החברות שלך במועדון תסתיים ב-{{date}}.\n\nרוצה לחדש את המועדון במחיר {{price}} ולהמשיך ליהנות מההטבות?",
		"expired_soon_accept": "חדשו לי!",
		"expired_soon_decline": "לא כרגע",
	},
    "NATIVE_PAYMENT": {
        "error_dialog_title": "לא ניתן לעבד את בקשתך כרגע.",
        "error_dialog_description": "בחר אמצעי תשלום אחר",
    },
	"MESSAGES": {
		"CONFIRM_SIGNOUT": "האם אתה בטוח שברצונך להתנתק מהמערכת?",
		"PAYMENT_CHALLENGE": "קוד אימות נשלח ל<i>{{phone}}</i>באמצעות SMS.",
		"PAYMENT_CHALLENGE_RETRY": "הקוד שהזנת שגוי!\nקוד אימות נוסף נשלח באמצעות SMS",
		"INVALID_ORDER": "<h4>העמוד לא זמין</h4>ייתכן שההזמנה הזו כבר נסגרה או שהקישור אינו תקף.",
		"SAVE_INFO_PAYMENT": "שמור פרטי תשלום",
		"PAYMENT_ACCEPTED_SUCCESSFULLY_WITH_AMOUNT": "תשלום של {{amount}} התקבל בהצלחה",
		"ITEM_ADDED_SUCCESSFULLY": "ההזמנה התעדכנה ונשלחה למטבח",
		"ITEM_ADDED_PENDING": "בקשה הזמנה נשלחה",
		"NO_PMS_FOUND": "לא נמצאו אמצעי תשלום בחשבונך.",
		"NO_SITE_PMS_FOUND": "לא נמצאו אמצעי תשלום למסעדה.",
		"PAYMENT_ACCEPTED_SUCCESSFULLY": "התשלום בוצע בהצלחה",
		"LIMIT_UPDATED_SUCCESSFULLY": "הבקשה בוצעה בהצלחה",
		"PAY_ORDER_CHANGED": "ההזמנה השתנתה! אנא עבור על ההזמנה.",
		"CONTINUE_WITHOUT_GRATUITY": "להמשיך ללא טיפ?",
		"GRATUITY_NOT_ALLOWED_FOR_PM": "במסעדה זו לא ניתן להוסיף טיפ ב{{pm}}.\nיש לבחור אמצעי תשלום אחר או לבטל את תוספת הטיפ.",
		"DO_YOU_APPROVE_CONTRACT": "האם את/ה מאשר/ת את תנאי השימוש?",
		"ENTER_ORDER_NO_INFO": "לצוות המסעדה יש קוד בשבילך",
		"saved_successfully": "נשמר בהצלחה",
		"Q_REMOVE_CARD": "האם אתה בטוח שברצונך למחוק כרטיס זה?",
		"deleted_successfully": "נמחק בהצלחה",
		"SIGNOUT_SUCCESS": "התנתקת בהצלחה מהמערכת",
		"GRATUITY_PA_WARNING": "במסעדה זו מקבלים טיפ ב{{pms}} בלבד",
		"SERVER_ERROR": "עמכם הסליחה, השירות אינו זמין באופן זמני,\n אנא נסו שוב מאוחר יותר",
        "SESSION_VALIDATION_FAILED": "אירעה שגיאה בעיבוד הבקשה, יש לרענן את העמוד ולנסות שוב",
		"PROBLEM_IN_PAYMENT_INPUT": "ארעה שגיאה בקליטת פרטי התשלום\nנא להזין את פרטי התשלום מחדש\nבמידה והבעיה ממשיכה, נא לפנות למסעדה בטלפון: \n {{phone}}",
		"CANNOT_PAY_TRAINING_MODE": "מערכת במצב תרגול. לא ניתן לסיים את העסקה. אנא התקשרו למסעדה\n {{phone}}",
		"ORDER_RELOAD_NEEDED": "נא לשים לב! הסכום לתשלום השתנה!",
		"OUT_OF_STOCK": "אופס!\n במהלך ההזמנה אזלו המנות:\n {{items}}\n יש לעדכן את ההזמנה בהתאם.",
		"PAYMENT_LOCKED": "אירעה שגיאה בביצוע התשלום, יש לנסות שנית",
		"ORDER_NEWPAYMENT_NEEDED": "לתשומת ליבך, היתרה לתשלום השתנתה. יש להזין סכום חדש",
		"ORDER_REQUIERES_IDCARD": "סכום התשלום גבוה מידי, אנא הקטן את הסכום או פנה למלצר",
		"PAYMENT_ERROR": "אנא וודאו נכונות פרטי התשלום",
		"EX_PAYMENT_ERROR": "ארעה שגיאה בביצוע התשלום",
		"ORDER_HELD_BY_SERVER": "אנו מתנצלים, אך לא ניתן לשלם ברגע זה. נא לנסות שוב בעוד כמה דקות",
		"SHVA_OFFLINE": "לא ניתן לבצע תשלומי אשראי במערכת כרגע. ניתן להחליף לאמצעי תשלום אחר או לנסות שנית מאוחר יותר.",
		"PAYMENT_NOT_SUPPORTED": "מתנצלים, המסעדה לא מקבלת כרגע את סוג הכרטיס הזה. נסו לשלם בכרטיס אחר",
		"CARD_VALIDATION_MISMATCH": "Card validation mismatch",
		"EX_PAYMENT_AUTHRIZATION_ERROR": "Error authorizing external payment",
		"PREAUTH_ERROR": "Your credit card has already been Pre-Authorized when you started the tab.\n\nPlease ask your server/bartender to cancel that Authorization if you wish to pay via your phone",
		"PAYMENT_QUOTA_EXCEEDED": "אין מספיק יתרה בכרטיס ({{v}})",
		"PAYMENT_ABOVE_CREDIT_MAX": "לא ניתן לשלם יותר מ1500 ש\"ח באותו הכרטיס. להמשך התשלום במסופון פיזי יש לפנות לצוות",
        "CREDIT_CARD_3DS_DISCLAIMER": "יתכן שתידרשו להזין קוד אימות שישלח אליכם מחברת האשראי במסרון או באימייל.",
		"CREDIT_CARD_3DS_DISCLAIMER_more": "בלחיצה על הכפתור ״לתשלום״, אני מאשר/ת את פרטי העסקה לחיוב ומצהיר/ה כי מדיניות ביטול העסקה ידועה לי ותואמת את הוראות חוק שירותי תשלום.",
		"INVALID_PAYMENT_AMOUNT": "Invalid payment amount",
		"ITEM_OUT_OF_STOCK_MESSAGE": "אופס!\n הפריט אזל מהמלאי!",
		"TABLE_X_NOT_FOUND": "אופס!\nשולחן {{v}} לא נמצא",
		"OUT_OF_BALANCE": "אופס! הגעתם למגבלת החשבון. \nרוצים להמשיך להזמין? \nבקשו מבעל החשבון להגדיל את המסגרת",
		"LOAD_RESOURCE_ERROR": "ארעה שגיאה",
	},
	"SERVER_MESSAGES": {
		"INVALID_ORDER_ID": "העסקה המבוקשת לא נמצאה",
		"EMAIL_NOT_FOUND": "Email לא נמצא במערכת",
        "CREDIT_GUARD_EX_ERROR": "התשלום ב CREDIT GUARD. נכשל!",
	},
	'PMS': {
		"creditCard": "אשראי",
		"creditGuard": "אשראי",
		"Cibus": "סיבוס",
		"10bis": "תן ביס",
		"adyen": "Adyen"
	},
	"PO": {
		"TABLE_BILL": "חשבון לשולחן",
		"WAITER": "מלצר",
		"ORDER_NO": "מספר הזמנה",
		"ORDERER_NAME": "שם המזמין",
		"ORDERER_PHONE": "טלפון",
		"ORDER_TO": "משלוח לכתובת",
		"OTH": "OTH",
		"ITEM_DISCOUNT": "הנחת פריט",
		"TICKET_DISCOUNT": "הנחת חשבון",
		"ORDER_DISCOUNT": "הנחת הזמנה",
		"TICKET_OTH": "הכל עלינו",
		"CHANGE": "טיפ\\עודף",
		"WITHOUT": "ללא",
		"ORDER_TOTAL": "סה\"כ הזמנה",
		"CHECK_TOTAL": "סה\"כ הזמנה",
		"ORDER_TIP": "תשר",
		"PAID": "שולם",
		"REMAINED_PAY": "נותר לתשלום"
	},
	"VALIDATIONS": {
		"CREDIT_CARD": "מס' כרטיס אינו חוקי",
		"CREDIT_CARD_EXPIRATION": "תוקף לא חוקי",
		"ID_CARD": "מס' תעודת זהות אינו חוקי",
		"NAME_FIELD": "אותיות בלבד!",
		"CELL_FIELD": "מספר סלולרי לא חוקי",
		"CELL_FIELD_MSG": "מספר סלולרי לא חוקי",
		"EMAIL_FIELD": "Email לא חוקי",
		"ZIPCODE": "מיקוד לא חוקי",
		"MAXLENGTH": "לא יכול להיות יותר מ-{{val}} תווים"
	},
	"_CODES": {
		"409012": "לא ניתן לחרוג מהיתרה לתשלום",
		"409023": "התשלום נכשל. יש לנסות שוב או להחליף אמצעי תשלום",
		"409028": "קיימים מסמכים שלא הופקו",
		"409030": "סיסמה קצרה מידי",
		"409036": "אנו מטפלים בתשלום קודם, אנא נסו שוב",
		"409039": "קיימים פריטים שלא הושלמו",
		"409040": "הפריט PARAM אזל במלאי",
		"409073": "נראה שהתשלום התמהמה. אנא נסו שוב.",
		"409091": "אופס.. נראה שיש בעיה. יש ליצור קשר עם המסעדה להשלמת ההזמנה (טלפון)",
		"409092": "אופס.. נראה שיש בעיה. יש ליצור קשר עם המסעדה להשלמת ההזמנה (טלפון)",
		"409093": "נראה שהתשלום התמהמה. אנא נסו שוב.",
		"409098": "שירות התשלומים אינו פעיל. אנא נסו שוב מאוחר יותר או החליפו אמצעי תשלום",
		"409110": "שליחת הSMS למספר [PARAM1] נכשלה, אנא נסו שנית",
		"409136": "ההזמנה נוצרה ונשלחה למסעדה",
		"409806": "מותג האשראי אינו נתמך במסעדה זו",
		"409808": "אמצעי התשלום פג תוקף",
		"409809": "אנא וודאו נכונות פרטי התשלום",
		"409810": "אנא וודאו נכונות פרטי התשלום",
		"409181": "HandoffRequiresPayment error"
	},
	"WEIGHT":{
		"GRAM": "גרם"
	},
	"_GIFTCARD": {
		"title": "כרטיס מתנה",
		"gift_card": "כרטיס מתנה",
		"gift_cards": "כרטיסי מתנה",
		"select_card": "בחר כרטיס מתנה",
		"please_select_card": "אנא בחר כרטיס מתנה",
		"edit_card": "עדכן כרטיס מתנה",
		"add_card": "הוסף כרטיס מתנה",
		"number": "מספר כרטיס",
		"amount": "סכום לתשלום",
		"balance": "סכום הכרטיס",
		"max": "מקסימום למימוש",
		"cvv": "CVV",
		"cvv_required": "חובה למלא CVV",
		"invalid_cvv": "מספר ה CVV שהוזן שגוי",
		"inuse_error": "לא ניתן לממש את אותו הכרטיס יותר מפעם אחת בהזמנה",
		"balance_error": "לא קיימת יתרה בכרטיס",
		"notfound_error": "פרטי הכרטיס שגויים או שהכרטיס אינו קיים במערכת",
		"delete_prompt": "להסיר את הכרטיס מההזמנה?",
		"no_order_amount": "התשלומים כבר מכסים את ההזמנה, אין צורך בתשלום נוסף 😎",
		"reset_split_payments_prompt": "הוספה או עדכון הכרטיס יאתחל את פיצול התשלומים! להמשיך?",
		"please_finish_payment": "לחצו ״תשלום״ לסיום",
		"otp_required": "קוד אימות נשלח למספר הטלפון",
		"otp_required_alt": "קוד אימות נשלח למספר הטלפון",
		"otp_required_alt_num": "{{v}}-****-***",
		"otp_alt": "קוד אימות",
		"invalid_otp": "קוד האימות שהוזן שגוי",
		"resend_otp": "שלחו לי שוב",
		"cannotPayOnOnline": "לא ניתן לשלם בכרטיס זה ברכישה אונליין, אלא במסעדה בלבד",
	},
	"ACCESS": {
		"ACCESSIBILITY": "תפריט נגישות",
		"ACCESSIBILITY_IN_PROGRESS": "האתר נמצא בתהליך הנגשה",
		"CLEAR_ACCESSIBILITY_FEATURES": "נקה אפשרויות נגישות",
		"monochrom": "מונוכרום",
		"light-contrast": "ניגודיות בהירה",
		"dark-contrast": "ניגודיות כהה",
		"enlarge-font": "הגדלת גופן",
		"reduce-font": "הקטנת גופן",
		"readable-font": "גופן קריא",
		"weelchair": "גובה ממשק",
		"big-white-curser": "סמן גדול לבן",
		"big-black-curser": "סמן גדול שחור",
		"enlarge-frame": "הגדלה",
		"highlight-links": "הדגשת קישורים",
		"highlight-headers": "הדגשת כותרות",
		"image-info": "תיאור לתמונות",
		"declaration": "הצהרת נגישות..."
	},
	"BADGES": {
		"new": "חדש",
		"sale": "מבצע",
	},
	"OAT": {
		"tab_welocme": "ברוכים הבאים ל {{v}}",
		"tab_welocme_desc": "איך מזמינים היום?",
		"table_number": "מספר שולחן",
		"table_no": "מספר שולחן {{v}}",
		"table_no_alt": "מספר שולחן <emlg>{{v}}</emlg>",
		"create_or_share_tab": "התחלת חשבון פתוח",
		"menu_prompt_title": "חשבון פתוח",
		"menu_prompt_desc": "התחילו או הצטרפו להזמנה קיימת",
		"menu_prompt_bottom_title": "חשבון פתוח",
		"menu_prompt_bottom_desc": "התחילו או הצטרפו להזמנה קיימת",
		"start_prompt": "ברוכים הבאים לדרך המהירה ביותר להזמין ולשלם בעצמכם",
		"order_from_the_menu": "הזמנה מהירה",
		"create_tab_order": "התחלת חשבון פתוח",
		"create_tab_order_desc": "בצעו אימות לכרטיס אשראי והתחילו להזמין, צרפו את החברים שבשולחן להזמנה",
		"join_tab_order": "הצטרפו להזמנה קיימת",
		"join_tab_order_desc": "הזינו את קוד ההזמנה בכדי להתחיל",
		"solo_order": "הזמנה מהירה",
		"solo_order_desc": "הזמן ושלם",
		"manage-tab-order": "ניהול הזמנה",
		"create_tab_title": "יצירת הזמנה חדשה",
		"create_tab_details_info": "דרך פשוטה להזמין עם חברים ובני משפחה",
		"field_tab_name": "שם ההזמנה",
		"default_tab_name": "ההזמנה של {{name}}",
		"field_full_name": "שם מלא",
		"field_phone": "טלפון נייד",
		"charge_disclaimer": "כדי לאבטח את אמצעי התשלום, אנחנו תופסים מסגרת אשראי של {{v}}. בפועל החיוב יתבצע רק על מה שהוזמן – עם סגירת החשבון.",
		"join_tab_title": "הצטרפו להזמנה קיימת",
		"join_tab_details_info": "הזינו את הקוד של ההזמנה כדי להצטרף. את הקוד יש לקבל מהיוצר של ההזמנה.",
		"field_order_no": "הזן קוד הזמנה",
		"manage_tab_title": "ניהול הזמנה",
		"manage_tab_details_info": "הסבר על ניהול הזמנה משותפת",
		"current_preauth": "סכום מוגבל",
		"remaining_preauth": "סכום שנשאר",
		"field_amount_imit": "הגבלת סכום",
		"increase_amount_limit": "הוסף סכום להגבלה",
		"increase_amount_limit_desc": "הוסף סכום להגבלה הנוכחית",
		"add_new_tab_limit": "הוסף הגבלת סכום חדשה",
		"share_my_tab": "שיתוף הזמנה",
		"close_my_tab": "תשלום וסגירת הזמנה",
		"share_order_title": "שתפו את ההזמנה",
		"share_order_info": "איזה כיף, הכל מוכן!",
		"share_order_qr_info": "שתפו את קוד ה־QR כדי לאפשר לחברים להצטרף להזמנה",
		"share_order_share_button": "שלחו לחברים",
		"share_order_link_button": "העתק קישור",
		"share_order_button_title": "Share header from button",
		"share_order_api_title": "Share header from sharing in browser",
		"desc_a": "אימות כרטיס אשראי",
		"desc_b": "הזמנה מהתפריט",
		"desc_c": "תשלום בסיום הארוחה",
		"share_tab_splash_title": "אופציונלי - שתפו את החשבון שלכם",
		"share_tab_splash_info": "שתפו עם חברים כך שיוכלו להזמין לחשבון שפתחתם",
		"review_before_sending_title": "נדרש אישור לפני שליחת פריטים למטבח",
		"review_before_sending_info": "פריטים שמוסיפים משתתפים אחרים יישלחו למטבח רק לאחר אישורך",
		"user_joined_tab": "{{name}} נוספו להזמנה",
		"close_tab_message": "<b>לסגור את החשבון ולהמשיך לתשלום?</b><br/>לא ניתן יהיה לבצע שינויים לאחר שלב זה",
		"action_in_progress_error": "אנחנו עדיין מעבדים את הבקשה הקודמת שלך. נסו שוב בעוד רגע",
		"ordered-by": "הוזמן ע\"י",
		"default_charge_tip": "במקרה של היעדר תשלום, ייתכן שיתווספו דמי שירות של {{val}}% בעת החיוב האוטומטי שיבוצע על ידי המערכת.",
		"fixed_charge_amount_title": "תחויבו רק בסכום הכולל בפועל",
		"fixed_charge_amount": "כדי לאבטח את הזמנתך, אנו מבצעים חיוב זמני של {{val}} דולר בכרטיס שלך. כאשר תסגור את הכרטיסייה, תחויב רק בסכום הכולל בפועל.",
		"share_anonymous_prompt": "<b>לצערנו אי אפשר ליצור חשבון פתוח במצב אורח</b><br/><br/>אבל אפשר בקלות להזמין ישירות מהתפריט.",
		"order_anonymous_from_the_menu": "הזמנה מהתפריט",
		"select_how_to_pay": "בחירת אופן תשלום",
		"pay_with_saved_card": "תשלום באמצעות הכרטיס השמור",
		"pay_in_full": "תשלום מלא",
		"partial_payment": "תשלום חלקי",
		"offers_pending_approval": "ממתינים לאישור",
		"offers_approve-all": "אשרו הכל",
		"offers_approve-decline": "אישור\\דחיית בקשות",
		"confirm_approve_all_requests": "לאשר את כל הבקשות?",
		"approve_selected_requests": "אשר בקשות נבחרות",
		"confirm_approve_selected_requests": "אשר בקשות נבחרות?",
		"decline_selected_requests": "ביטול בקשות נבחרות",
		"confirm_decline_selected_requests": "ביטול בקשות נבחרות?",
	},
	'_TABLEO': {
		'start_prompt': 'הסבר על הזמנת שולחן',
		'new_table_order': 'הזמנת שולחן חדשה',
		'join_table_order': 'הצטרפו להזמנה קיימת',
		'err_creating_table_order': 'ארעה שגיאה ביצירת הזמנת שולחן',
		'order_forphone_exist': 'המזמין לא יכול לפתוח מספר הזמנות בישיבה'
	},
	'TD': {
		'menu_title': 'הוספת פריטים להזמנה',
		'to-update': "עדכון",
		'to-add': "הוספה",
		'clear_selection': 'ניקוי בחירה',
		'cancel': 'ביטול',
		'my-order': 'ההזמנה שלי',
		'items-summary': 'סיכום הזמנה',
		'add-items': 'אישור והוספה',
		"no_basket_items": "אין פריטים בסל",
		"find_offers": 'חיפוש...',
		"msg_timeout": "אופס! נראה שעבר יותר מידי זמן ויש להתחיל את ההזמנה מחדש",
		"msg_expired": "מתנצלים, נראה שעבר יותר מידי זמן ויש להתחיל את ההזמנה מחדש",
		"restart_order": "התחל מחדש",
		"continue": "המשך",
		"payup": "המשך לתשלום",
		"not_interested": "לא הפעם, תודה",
		"not_interested_alt": "לא הפעם, המשך",
		"additional_offers": "תוספות ורטבים",
		"select_additional_offers": "בחרו תוספות ורטבים",
		"prep_time": "זמן הכנה משוער <b>{{v}}</b> דקות",
		"historic_orders": "הזמנתם בעבר",
		"loading": "",
		"alcohol_decleration": "אני מעל גיל {{age}} וככל שידרש, אציג תעודה מזהה לאימות לצורך קניית אלכוהול.",
		"service_unavailable": "<h4>מתנצלים</h4>השירות אינו זמין כרגע",
		"missing_configuration": "<h4>מתנצלים</h4>השירות אינו זמין כרגע",
		"takeaway_not_supported": "<h4>מתנצלים</h4>השירות אינו זמין כרגע",
		"service_outside_workhours": "<h4>מתנצלים</h4>השירות אינו זמין כרגע",
		"offers_not_matched": "<b>לא כל הפריטים מההזמנה הקודמת זמינים כרגע.</b><br><br>{{offers}}<b><br><br>שנמשיך בכל זאת?</b>",
		"offer_not_available": "{{name}} אינו זמין",
	},
	'TO': {
		'menu_title': 'הזמן ושלם',
		'extraoffers_title': 'הצעות נוספות',
		'tip_title': 'טיפ',
		'pay_title': 'תשלום',
		'continue-from-summary': 'המשך',
		'back-to-menu': 'הוסף פריטים',
		'tax': 'מיסים',
		'fees': 'עמלות',
		'tip': 'טיפ',
		'total-to-pay': 'סה\"כ לתשלום',
		'total-items': 'סה\"כ פריטים',
		'restart-order': 'התחלת הזמנה מחדש',
		'add_another_order': 'הזמנה נוספת',
		'reorder': 'התחלת הזמנה נוספת',
		"q_confirm_reset_order": "להתחיל את ההזמנה מחדש?",
		"q_remove_offer_from_basket": "להסיר את הפריט?",
		"end_success_title": "ההזמנה נשלחה בהצלחה למטבח",
		"change_to_takeaway": "שינוי לאיסוף עצמי",
		"q_change_to_takeaway": "שינוי לאיסוף עצמי?",
		"dine_in": "הזמן ושב",
		"change_to_takeaway_unavailable": "מתנצלים\\nהשרות אינו פעיל כעת",
		"takeaway_title": "איסוף עצמי",
		"add_items_prompt": "לאחר ההזמנה, \nהמנות יופיעו כאן",
		"offer_added_toast": "נבחר: {{val}}",
		"table_number_title": "בחרו מספר שולחן",
		"enter_table_number": "מספר שולחן",
		"takeaway_instead": "לא רוצים לשולחן? הזמינו לאיסוף עצמי"

	},
	'_APP': {
		"open-cam-prompt": "מוכנים להזמין?",
		"open-cam-desc": "התחל על ידי סריקת קוד ה-QR על השולחן שלך\nכל שעליך לעשות הוא לפתוח את מצלמת המכשיר שלך כדי להתחיל",
		"scan-qr-desc": "התחל על ידי סריקת קוד ה-QR על השולחן שלך\nכל שעליכם לעשות הוא ללחוץ כדי להתחיל.",
		"open-cam-desc-signed": "כבר במסעדה?\\nפתחו את מצלמת המכשיר שלך כדי לסרוק את קוד ה-QR.",
		"scan-qr-signed": "כבר במסעדה?\\nלחצו כדי לסרוק את קוד ה-QR",
		"login-prompt": "כבר הזמנתם אצלנו?\\nהיכנסו כאן",
		"no-orders-title": "נראה שעדיין לא הזמנתם",
		"no-orders-desc": "לאחר שתעשו זאת, ההזמנות האחרונות והמסעדות המועדפות שלך יופיעו כאן.",
		"recent-sites": "מסעדות שביקרתם  בהן לאחרונה",
		"recent-orders": "הזמנות אחרונות",
		"invalid-qr-scan": "מתנצלים\\nה QR שנסרק אינו חוקי",

	},
	"without": "ללא",
	"GROUP_VALIDATION": {
		"select_one": "בחרו אחד",
		"between_amount": "בין {{min}} ל {{max}}",
		"GROUP_MOD_SELECT_SINGLE_ERROR": "בחרו לפחות תוספת אחד מ: {{group}}",
		"GROUP_SELECT_ERROR": "בחרו לפחות {{count}} פריטים מ: {{group}}",
		"GROUP_SELECT_SINGLE_ERROR": "בחרו לפחות פריט אחד מ: {{group}}",
		"SELECT_ATLEAST_ONE": "בחרו לפחות פריט אחד",
		"SELECT_ATLEAST_SOME": "בחרו לפחות {{min}} פריטים",
		"SELECT_BETWEEN": "בחרו בין {{min}} ל {{max}} פריטים",
		"SELECT_ONE": "בחרו פריט אחד",
		"SELECT_SOME": "בחרו {{min}} פריטים",
		"SELECT_UPTO_ONE": "בחרו עד פריט אחד",
		"SELECT_UPTO_SOME": "בחרו עד {{max}} פריטים",
		"SELECT_UPTO_SOME_ALT": "עד {{max}} פריטים",
		"MAX_ITEMS_COUNT": "לא ניתן להזמין יותר מ {{max}} פריטים!",
		"MAX_ITEMS_AMOUNT": "לא ניתן להזמין  פריטים בסכום העולה על  {{max}}!",
		"MOD_CANT_SELECT_MORE_THEN": "יש לבחור לא יותר מ {{max}} תוספות!",
		"OUT_OF_STOCK": "אופס!\n במהלך ההזמנה אזלו המנות:\n {{items}}\n יש לעדכן את ההזמנה בהתאם.",
	},
	"tabot": {
		"confirm_reset_title": "איפוס צ'אט",
		"confirm_reset_message": "האם אתה בטוח שאתה רוצה לאפס את הצ'אט? פעולה זו תמחק את כל ההודעות והסל.",
		"confirm_reset_yes": "כן, אפס",
		"confirm_reset_no": "ביטול",
		"general_error": "אירעה שגיאה כללית. אנא נסה שוב.",
		"offer_not_found": "לא נמצאה הצעה מתאימה.",
		"processing": "מעבד את הבקשה...",
		"processing_retry": "מעבד את הבקשה... (ניסיון {{attempt}} מתוך {{maxAttempts}})",
		"error_with_code": "שגיאה: {{message}} (קוד: {{statusCode}})",
		"network_error": "שגיאת רשת. אנא בדוק את החיבור לאינטרנט.",
		"timeout_error": "תם הזמן הקצוב לבקשה. אנא נסה שוב.",
		"max_retries_exceeded": "מספר הניסיונים המקסימלי הושג. אנא נסה שוב מאוחר יותר.",
		"unexpected_error": "אירעה שגיאה לא צפויה. אנא נסה שוב.",
		"successful_message": "ההזמנה בוצעה בהצלחה!",
		"basket_error": "שגיאה בעדכון הסל.",
		"invalid_response": "תגובה לא תקינה מהשרת.",
		"no_offers": "לא נמצאו הצעות.",
		"chat_error": "שגיאה בצ'אט.",
		"error": "שגיאה",
		"empty_basket": "הסל ריק.",
		"feedback_needed": "נדרשת משוב מהמשתמש.",
		"single_item_added": "{{item}} נוסף לסל.",
		"multiple_items_added": "נוספו לסל: {{items}}.",
		"single_item_needs_edit": "{{item}} דורש עריכה.",
		"multiple_items_need_edit": "הפריטים הבאים דורשים עריכה: {{items}}.",
		"multiple_items_need_edit_error": "קיימים פריטים אשר דורשים עריכה",
		"creating_order": "יוצר לכם את הפריטים להזמנה...",
		"checking_order": "בדיקת הזמנה...",
		"header_title": "Tabot - העוזר האישי שלך להזמנה במסעדה",
		"mobile_header_title": "TABOT",
		"input_placeholder": "כתוב הודעה...",
		"voice_message_sent": "הודעת קול נשלחה",
		"voice_message_transcribed": "הודעת הקול תורגמה: ${text}",
		"voice_message_error": 'שגיאה בשליחת הודעת קול',
		"sync_basket": "סנכרן סל",
		"out_of_stock": "אזל מהמלאי",
		"text_size": "גודל טקסט",
		"edit_offer": "ערוך הצעה",
		"delete_offer": "מחק הצעה",
		"free_search": "חיפוש חופשי...",
		"offers_need_input": "הפריטים הבאים דורשים קלט נוסף",
		"find_me": "חפש אותי..."
	}
};
